import { type FC } from 'react'
import { type InsightsWorkflowScope, useInsightsWorkflowLauncher } from './useInsightsWorkflowLauncher'
import { WorkflowsMenu } from './WorkflowsMenu'

export const InsightsWorkflowsMenu: FC<InsightsWorkflowScope> = (scope) => {
  const launcher = useInsightsWorkflowLauncher(scope)
  return <WorkflowsMenu launcher={launcher} dropdownClassName='insights-workflows-menu' />
}
